import React, { useMemo, useState } from 'react';
import { API_OwnNft } from 'shared';
import useMint from '../../../../../../hooks/useMint';
import Button from '../../../../../controls/button';
import useAlert from '../../../../../../contexts/alert';
import useInitFight from '../../../../../../contexts/initFight';

interface Props {
  nft: API_OwnNft;
  update: (stopLoading?: () => any) => any;
}

const HomeNftDescButton = ({ nft, update }: Props) => {
  const { mint } = useMint();
  const alert = useAlert();
  const { openPickDialog } = useInitFight();
  const [loading, setLoading] = useState(false);

  const handleClick = () => {
    if (nft.failed) {
      if (nft.minted) return;
      return mint(setLoading, nft.token, nft.price, () => {
        alert.show('Transaction is initiated');
        update(() => setLoading(false));
      });
    }
    setLoading(true);
    if (nft.pending) {
      update(() => setLoading(false));
    } else {
      openPickDialog(nft, () => setLoading(false));
    }
  };

  const buttonText = useMemo<string>(() => {
    if (nft.failed) {
      if (nft.minted) {
        return 'Minted By Somebody Else';
      }
      return 'Mint Again';
    }
    if (nft.pending) {
      return 'Update Status';
    }
    return 'Fight Now';
  }, [nft]);

  return (
    <Button
      color='primary'
      variant='contained'
      loading={loading}
      onClick={handleClick}
      disabled={nft.failed && nft.minted}
    >
      {buttonText}
    </Button>
  );
};

export default HomeNftDescButton;
